"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Client = void 0;
const tslib_1 = require("tslib");
const date_fns_1 = require("date-fns");
class Client {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    geographicAddress(address) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield this.httpClient.get(`/api/v2/geographicAddress?address=${address}`);
        });
    }
    serviceQualificationQuery(geographicAddress) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield this.httpClient.post(`/api/v2/queryServiceQualification`, this.buildRequestObject(geographicAddress));
        });
    }
    buildRequestObject(geographicAddress) {
        const now = Date.now();
        return {
            '@baseType': 'QueryServiceQualification',
            '@type': 'QueryServiceQualification',
            description: `Service qualification query from @uniti/sq-js-client at ${date_fns_1.formatISO(now)}`,
            expectedQualificationDate: date_fns_1.formatISO(now),
            instantSyncQualification: true,
            externalId: '',
            searchCriteria: {
                '@baseType': 'SearchCriteria',
                '@type': 'SearchCriteria',
                service: {
                    '@baseType': 'ServiceRefOrValue',
                    '@type': 'Service',
                    place: [
                        geographicAddress
                    ],
                    serviceCharacteristic: []
                }
            },
            serviceQualificationItem: []
        };
    }
}
exports.Client = Client;
//# sourceMappingURL=client.js.map